import PropTypes from 'prop-types';
import { AutoCompleteItemWrapper } from './styled';

const AutoCompleteItem = (props) => {
  const { name, type } = props;
  return (
    <AutoCompleteItemWrapper>
      <span>{name}</span>
      <span>{type}</span>
    </AutoCompleteItemWrapper>
  );
};

AutoCompleteItem.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default AutoCompleteItem;
